import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./auth.css";
import { loginUser, getAuthErrorMessage } from "../../utils/functionFirebase";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("يرجى إدخال البريد الإلكتروني وكلمة المرور.");
      return;
    }
    setError("");
    const result = await loginUser(email, password);
    if (result.success) {
      toast.success("تم تسجيل الدخول بنجاح!");
      navigate("/"); // إعادة التوجيه للصفحة الرئيسية
    } else {
      // إذا كان الخطأ من Firebase، استخدم getAuthErrorMessage
      const errorMsg = result.error && result.error.startsWith("auth/")
        ? getAuthErrorMessage(result.error)
        : (result.error || "فشل تسجيل الدخول. تأكد من صحة البيانات.");
      setError(errorMsg);
    }
  };

  return (
    <>
    

    <div >
      <div >
        <h2 className="mb-4 text-center">تسجيل الدخول</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="register-label">البريد الإلكتروني</label>
            <input
              type="email"
              className="register-input"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="أدخل بريدك الإلكتروني"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="register-label">كلمة المرور</label>
            <input
              type="password"
              className="register-input"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة المرور"
            />
          </div>
          <button type="submit" className="register-btn">تسجيل الدخول</button>
        </form>
        
      </div>
      
    </div>
    
    </>
  );
};

export default Login;
